import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from './ui/button';

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <header className="bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 shadow-xl border-b-4 border-teal-500 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3 group">
            <img 
              src="https://customer-assets.emergentagent.com/job_e8fa7a8f-9528-415e-9461-a6ce6bc2c2cd/artifacts/clrl25ds_IMG_7484.jpeg" 
              alt="Legacy Motorplex" 
              className="h-14 w-auto group-hover:scale-105 transition-transform"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-gray-300 hover:text-teal-400 transition-colors font-bold text-base">
              Home
            </Link>
            <Link to="/inventory" className="text-gray-300 hover:text-teal-400 transition-colors font-bold text-base">
              Inventory
            </Link>
            <Link to="/about" className="text-gray-300 hover:text-teal-400 transition-colors font-bold text-base">
              About Us
            </Link>
            <Link to="/contact" className="text-gray-300 hover:text-teal-400 transition-colors font-bold text-base">
              Contact
            </Link>
            <a href="tel:4047231672" className="flex items-center space-x-2 bg-gradient-to-r from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700 text-white px-4 py-2 rounded-lg transition-all font-bold shadow-lg shadow-teal-500/50">
              <Phone className="h-5 w-5" />
              <span>(404) 723-1672</span>
            </a>
          </nav>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-teal-400 hover:text-teal-300 transition-colors"
          >
            {isMenuOpen ? <X className="h-7 w-7" /> : <Menu className="h-7 w-7" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="md:hidden py-6 space-y-4 border-t-2 border-teal-500">
            <Link 
              to="/" 
              className="block text-gray-300 hover:text-teal-400 transition-colors font-bold text-lg"
              onClick={() => setIsMenuOpen(false)}
            >
              Home
            </Link>
            <Link 
              to="/inventory" 
              className="block text-gray-300 hover:text-teal-400 transition-colors font-bold text-lg"
              onClick={() => setIsMenuOpen(false)}
            >
              Inventory
            </Link>
            <Link 
              to="/about" 
              className="block text-gray-300 hover:text-teal-400 transition-colors font-bold text-lg"
              onClick={() => setIsMenuOpen(false)}
            >
              About Us
            </Link>
            <Link 
              to="/contact" 
              className="block text-gray-300 hover:text-teal-400 transition-colors font-bold text-lg"
              onClick={() => setIsMenuOpen(false)}
            >
              Contact
            </Link>
            <a href="tel:4047231672" className="flex items-center space-x-2 bg-gradient-to-r from-teal-500 to-teal-600 text-white px-4 py-3 rounded-lg font-bold shadow-lg">
              <Phone className="h-5 w-5" />
              <span>(404) 723-1672</span>
            </a>
          </nav>
        )}
      </div>
    </header>
  );
};
